<template>
    <div>
        <media-form
            :is-media-form-sidebar-active.sync="isMediaFormSidebarActive"
            :mediaGalleryData="mediaGalleryData"
            @refetch-data="refetchData"
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                                variant="primary"
                                @click="updateMedia()"
                            >
                                <span class="text-nowrap">Add Media</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                v-if="!mediaGalleries.length"
                :items="mediaGalleries"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>
            <table v-else class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="(col, index) in tableColumns" :key="index">
                        {{ col.label }}
                    </th>
                    </tr>
                </thead>
                <draggable v-model="mediaGalleries" tag="tbody" hadle=".handle" @change="updateOrdering()">
                    <tr v-for="(item, index) in mediaGalleries" :key="index">
                        <th scope="row" class="pl-2">
                            <MenuIcon icon="MenuIcon"/> 
                        </th>
                        <td class="pl-2">
                            <span>{{ item.title[currentLocale] }}</span>
                        </td>
                        <td class="pl-2">
                            <span v-html="(item.slug[currentLocale])"></span>
                        </td>
                        <td class="pl-2">
                            <span>{{ item.type.type }}</span>
                        </td>
                        <td class="pl-2">
                            <b-badge
                                pill
                                :variant="`light-${resolveStatusVariant(item.is_active)}`"
                                class="text-capitalize"
                            >
                                {{ resolveStatusnameVariant(item.is_active) }} 
                            </b-badge>
                        </td>
                        <td class="pl-2">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateMedia(item)" variant="outline-success">Edit</b-button>
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                        </td>
                    </tr>
                </draggable>
            </table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalMediaGalleries"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup,
    BFormCheckbox, BImg
} from 'bootstrap-vue';
import { ref,onUnmounted } from '@vue/composition-api'
import { FeatherIcon, MenuIcon } from 'vue-feather-icons'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive';
import draggable from 'vuedraggable'
import store from '@/store'
import useMediaGalleryList from '../media-list/useMediaGalleryList'
import mediaGalleryStoreModule from '../mediaGalleryStoreModule'
import mediaForm from '../MediaGalleryForm.vue'
import folderStoreModule from '../../files/filesStoreModule'

export default {
    components: {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox, 
        draggable, MenuIcon, BImg, mediaForm, vSelect,
    },

    directives: {
        'b-modal': VBModal,
        Ripple
    },

    computed: {
        currentLocale() {
            return  this.$i18n.locale;
        },
    },

    setup() {
        const MEDIA_STORE_MODULE_NAME = 'app-media';
        if (!store.hasModule(MEDIA_STORE_MODULE_NAME)) store.registerModule(MEDIA_STORE_MODULE_NAME, mediaGalleryStoreModule)
        onUnmounted(() => {
            if (store.hasModule(MEDIA_STORE_MODULE_NAME)) store.unregisterModule(MEDIA_STORE_MODULE_NAME)
        });

        // const FOLDER_STORE_MODULE_NAME = 'files-folder'
        // if (!store.hasModule(FOLDER_STORE_MODULE_NAME)) store.registerModule(FOLDER_STORE_MODULE_NAME, folderStoreModule)
        // onUnmounted(() => {
        //     if (store.hasModule(FOLDER_STORE_MODULE_NAME)) store.unregisterModule(FOLDER_STORE_MODULE_NAME)
        // });

        const {
            updateMedia,
            searchQuery,
            refMediaListTable,
            isSortDirDesc,
            sortBy,
            tableColumns,
            mediaGalleries,
            dataMeta,
            totalMediaGalleries,
            perPage,
            currentPage,
            isMediaFormSidebarActive,
            mediaGalleryData,
            refetchData,
            fetchData,
            resolveStatusVariant,
            resolveStatusnameVariant,
            typeFilter,
            typeData,
            updateOrdering,
            deleteData,
        } = useMediaGalleryList()

        fetchData()

        return {
            updateMedia,
            searchQuery,
            refMediaListTable,
            isSortDirDesc,
            sortBy,
            tableColumns,
            mediaGalleries,
            dataMeta,
            totalMediaGalleries,
            perPage,
            currentPage,
            isMediaFormSidebarActive,
            mediaGalleryData,
            refetchData,
            fetchData,
            resolveStatusVariant,
            resolveStatusnameVariant,
            typeFilter,
            typeData,
            updateOrdering,
            deleteData,
        }
    },
    methods: {
        deleteconfirm(id){
            this.$bvModal
                .msgBoxConfirm(`Please confirm that you want to delete ID = ${id}`, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                    this.deleteData(id)
                }
            })
        },
    }
}
</script>